
import { useState } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useComments } from "./CommentsContext";

interface CommentFormProps {
  pinId: string;
  user: any;
}

export function CommentForm({ pinId, user }: CommentFormProps) {
  const [newComment, setNewComment] = useState("");
  const { handleSubmitComment, isSubmitting } = useComments();

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await handleSubmitComment(pinId, newComment);
    setNewComment("");
  };

  return (
    <form onSubmit={onSubmit} className="mb-6">
      <div className="flex gap-3">
        <Avatar className="h-8 w-8">
          <AvatarImage src={user?.avatar_url} />
          <AvatarFallback>
            {user?.username?.charAt(0)?.toUpperCase() || "U"}
          </AvatarFallback>
        </Avatar>
        <div className="flex-1 flex gap-2">
          <Input
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            placeholder="Adicione um comentário..."
            className="flex-1"
            disabled={isSubmitting}
          />
          <Button type="submit" disabled={!newComment.trim() || isSubmitting}>
            Enviar
          </Button>
        </div>
      </div>
    </form>
  );
}
